import React from 'react';
import { isEqual } from 'lodash';

import GeneralInformationDetailsCard from './Primary/GeneralInformationDetailsCard';
import WorksiteLocationDetailsCard from './Primary/WorksiteLocationDetailsCard';
import AssignmentInformationDetailsCard from './Primary/AssignmentInformationDetailsCard';
import FinancialInformationDetailsCard from './Primary/FinancialInformationDetailsCard';
import CustomerInformationDetailsCard from './Primary/CustomerInformationDetailsCard';
import SplitInformationDetailsCard from './Primary/SplitInformationDetailsCard';
import AdditionalInformationDetailsCard from './Additional/AdditionalInformationDetailsCard';
import {
  HistoryResponseModel,
  AssignmentHistoryDetailsModel,
} from 'api/adminApiClient';

type Props = {
  historyItem: HistoryResponseModel;
};

export default function AssignmentDetailsCard(props: Props) {
  const { historyItem } = props;

  const historyDetails = historyItem.details as AssignmentHistoryDetailsModel;
  const historyId = historyItem.id || '';

  const hasAdditionalInformationChanged = !isEqual(
    historyDetails.oldData?.additionalInfo || '',
    historyDetails.newData?.additionalInfo || '',
  );
  const hasSplitPartnerInfoChanged = !isEqual(
    historyDetails.oldData?.splitPartnerInfo || '',
    historyDetails.newData?.splitPartnerInfo || '',
  );

  return (
    <>
      <GeneralInformationDetailsCard
        historyDetails={historyDetails}
        historyId={historyId}
      />
      <WorksiteLocationDetailsCard
        historyDetails={historyDetails}
        historyId={historyId}
      />
      <CustomerInformationDetailsCard
        historyDetails={historyDetails}
        historyId={historyId}
      />
      <AssignmentInformationDetailsCard
        historyId={historyId}
        historyDetails={historyDetails}
      />
      <FinancialInformationDetailsCard
        historyId={historyId}
        historyDetails={historyDetails}
      />
      {hasSplitPartnerInfoChanged && (
        <SplitInformationDetailsCard
          historyId={historyId}
          historyDetails={historyDetails}
        />
      )}
      {hasAdditionalInformationChanged && (
        <AdditionalInformationDetailsCard
          historyId={historyId}
          historyDetails={historyDetails}
        />
      )}
    </>
  );
}
